/**
* Case Studies Tabs JS
* -----------------------------------------------------------------------------
*
* All the JS for the Case Studies Tabs component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'case-studies-tabs',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );
      $( '.case-studies-tabs' ).each( function( key, component ) {
        $( component ).find( '.case-study-title' ).on( 'click', function() {
          // activate/decative titles
          $( this ).addClass( 'is-active' );
          $( component ).find( '.case-study-title' ).not( this ).removeClass( 'is-active' );

          // activate/deactivate boxes
          $( this ).closest( '.tab-box' ).addClass( 'is-active' );
          $( component ).find( '.tab-box' ).not( $( this ).closest( '.tab-box' ) ).removeClass( 'is-active' );

          // show/hide info
          $( component ).find( '.case-study-info' ).not( $( this ).next() ).slideUp();
          $( this ).next().slideDown();

          // show/hide desktop image
          $( component ).find( '.case-study-image' ).not( '[data-id="' + $( this ).attr( 'data-id' ) + '"]' ).fadeOut();
          $( component ).find( '.case-study-image[data-id="' + $( this ).attr( 'data-id' ) + '"]' ).fadeIn();

          // show/hide mobile image
          $( component ).find( '.case-study-image-mobile' ).not( '[data-id="' + $( this ).attr( 'data-id' ) + '"]' ).slideUp( 500 );
          $( component ).find( '.case-study-image-mobile[data-id="' + $( this ).attr( 'data-id' ) + '"]' ).slideDown( 500 );
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'case-studies-tabs', COMPONENT );
} )( app );
